<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { onMounted, ref } from 'vue'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { formatTableDataFlashOffer } from '../helper/table'
import { useRouter } from 'vue-router'

interface Props {
  id: string | number;
}

const props = defineProps<Props>()
const router = useRouter()
const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(1)
interface DataSource {
  list: any[];
  totalPage: number;
  totalRecords: number;
}

const dataSource = ref<DataSource>({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (newPage: number) => {

  page.value = newPage;
  requestFetchData()
}

const handleChangePageSize = (size: number) => {

  pageSize.value = size
  requestFetchData()
}

const requestFetchData = async () => {
  try{
    const res = await APIClient.get(FlashOfferAPI.flashoffer.list, {
      params: {
        page: page.value,
        page_size: pageSize.value,
        listing_code: props.id,
      }
    });

    const { data } = res.data;
    if (res.data.code === 200) {
      dataSource.value = {
        list: formatTableDataFlashOffer(data.data) || [],
        totalPage: data.last_page,
        totalRecords: data.total,
      }
    }
  } catch (e) {
    console.error('Error fetching flash offers:', e)
  }
}

onMounted(() => {
  requestFetchData()
})

const handleGotoDetail = (e: MouseEvent, item: any) => {

  router.push({ name: 'flash-offer-detail', params: { id: item.id } })
  // flashOfferListStore.newTab({id: item.code, label: `#${item.code} - ${item.subject?.title}`, active: true})
}
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        id: { label: 'ID', component: TextCell, class: '', visible: true, sort: false, config: {} },
        started_at: { label: 'Ngày bắt đầu', component: DateTimeCell, class: '', visible: true, sort: '', config: {} },
        ended_at: { label: 'Ngày kết thúc', component: DateTimeCell, class: '', visible: true, sort: '', config: {} },
        status_text: { label: 'Trạng thái', component: TagCell, class: '', visible: true, sort: false, config: {} },
        name: { label: 'Tên sự kiện', component: TextCell, class: '', visible: true, sort: false, config: {} },
        total_items: { label: 'Số lượng mở bán', component: NumberCell, class: 'justify-end', visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày đăng ký', component: DateTimeCell, class: '', visible: true, sort: 'desc', config: {} },
        created_by: { label: 'Người tạo', component: TextCell, class: '', visible: true, sort: false, config: {} },
      }
    }"
    :row-action-buttons="[
      { action: handleGotoDetail, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone' }
    ]"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
